// Dependecies
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';

// Components
import Template from '../../components/Template';
import FixedJobRequest from '../../components/JobRequest';

// hooks
import useBenefit from '../../hooks/useBenefits';
import useNotificationRead from '../../hooks/useNotificationRead';

function Benefit() {
  const { benefits } = useBenefit();
  const { t } = useTranslation(['benefit', 'alt']);
  const { newMaintenancesCompany } = useNotificationRead();

  return (
    <Template
      type={4}
      newMaintenances={newMaintenancesCompany}
      classNameContainer="benefit"
      className="container_menu benefit"
    >
      <FixedJobRequest />
      <div className="content_dynamic benefit_content company">
        <div className="col-md-12">
          <h1 className="title-benefits">{t('benefits')}</h1>
        </div>
        {benefits ? (
          <Row className="content-onboarding">
            {benefits.map((benefit) =>
              benefit.is_company === 1 ? (
                <Col key={benefit.id} xs={12} md={8} lg={4} className="benefits-aling">
                  <div className="card-benefits">
                    <div className="content-image-onboarding">
                      <img className="imag_benefits" src={benefit.image} alt={benefit.title} />
                    </div>
                    <div className="line-benefits" />
                    <div className="content-text-onboarding">
                      <h3>
                        <strong>{benefit.title}</strong>
                      </h3>
                      <p>{benefit.description}</p>
                    </div>
                  </div>
                </Col>
              ) : (
                ''
              )
            )}
          </Row>
        ) : (
          <h3>
            <strong>{t('no-benefits')}</strong>
          </h3>
        )}
      </div>
    </Template>
  );
}

export default Benefit;
